import React from 'react';

const LinkedInLogo = (props) => {
	return (
		<div class="linkedin_logo mod_align_center">
			<svg width="30px" height="30px" viewBox="0 0 30 30">
				<g>
					<circle cx="6.5" cy="6.5" r="2.5"/>

					<path d="M20.67,11c-2.24,0-3.38,0.56-4.37,1.78V11H12v15h4.31v-8.35c0-1.56,1.24-3.01,2.77-3.01c2.6,0,2.6,2.98,2.6,4.23V26H26c0,0,0-4.47,0-9.27C26,11.92,23.38,11,20.67,11z"/>

					<rect x="4" y="11" width="5" height="15"/>
				</g>
			</svg>

		</div>
	)
}

export default LinkedInLogo;